import { HttpClient } from "../../../services/http/http-client";
import { MHTTPCL, JSON_STRING ,createHttpGetOptions} from "../../../services/http/http-client";
import { LABEL_URL, BELIEVE_CONTROLLER_URL, CONTACTS_URL, MODIFICATION_URL, DISTRIBUTION_URL } from "../../../services/common-urls";
const SUPPLIERS = 'suppliers';
export const SuppliersService = {

  getNewSupplierFormData: () => HttpClient.get(DISTRIBUTION_URL, {
    section: SUPPLIERS,
    action: "new_supplier_form",
    output: "json",
  }),

  addNewSupplier: (supplier_name, supply_order_type) => HttpClient.post(DISTRIBUTION_URL, {
    section: SUPPLIERS,
    action: "add_supplier",
    supplier_name,
    supply_order_type,
    output: "json",
  }),
  getSuppliersList: () => HttpClient.get(DISTRIBUTION_URL, {
    section: SUPPLIERS,
    action: "dist_suppliers_tab_suppliers_list",
    output: "json",
  }),
  getFilteredSuppliersList: (serachText) => HttpClient.get(DISTRIBUTION_URL, {
    section: SUPPLIERS,
    action: "search_suppliers",
    search_key: serachText,
    output: "json",
  }),
  removeSupplier: (supplier_id) => HttpClient.get(DISTRIBUTION_URL, {
    section: SUPPLIERS,
    action: "remove_supplier",
    supplier_id: supplier_id,
    output: "json",
  }),


  loadFilterSupplierProducts: ({ supplier_id, search, release_month }) =>
    MHTTPCL.get(DISTRIBUTION_URL, {
      section: SUPPLIERS,
      action: "load_supplier_products",
      supplier_id,
      search,
      release_month,
      output: JSON_STRING
    }),
  removeSupplierProducts: ({ product_id }) => HttpClient.post(DISTRIBUTION_URL, {
    section: SUPPLIERS,
    action: "remove_supplier_products",
    product_id: product_id,
    output: "json",
  }),
  fetchDistributionSupplierDetailsTabSetup: supplier_id =>
    MHTTPCL.get(DISTRIBUTION_URL, {
      section: SUPPLIERS,
      action: "supplier_details",
      supplier_id,
      output: JSON_STRING
    }),
  getSubtabStockCheckData: (supplier_id) =>
    MHTTPCL.get(DISTRIBUTION_URL, {
      section: SUPPLIERS,
      action: "subtab_stock_check_data",
      supplier_id: supplier_id,
      output: JSON_STRING
    }),
    exportStockCheckData: (supplier_id, label_ids = '') => HttpClient.postJSONasFormData(DISTRIBUTION_URL, {
      section: SUPPLIERS,
      action: 'export_stock_check_data',
      supplier_id: supplier_id,
      label_ids: label_ids,
    }, createHttpGetOptions({ responseType: 'blob' })),




  createSupplyOrderData: (data) =>
    MHTTPCL.post(DISTRIBUTION_URL, {
      section: SUPPLIERS,
      action: "create_supplier_order",
      ...data,
      output: JSON_STRING
    }),
  fetchDistributionSupplierDetailsTabStockCheck: (supplier_id, label_ids = '') =>
    MHTTPCL.get(DISTRIBUTION_URL, {
      section: SUPPLIERS,
      action: "stock_check_data",
      supplier_id: supplier_id,
      label_ids: label_ids,
      output: JSON_STRING
    }),

  modify: ({ table, kVal, name, value }) => MHTTPCL.post(MODIFICATION_URL, {
    table,
    kVal,
    name,
    value,
    output: JSON_STRING
  }),

  fetchProductTypes: () =>
    MHTTPCL.get(DISTRIBUTION_URL, {
      section: SUPPLIERS,
      action: "product_types",
      output: JSON_STRING
    }),
  searchProducts: ({ supplier_id, str, product_type_id }) =>
    MHTTPCL.get(DISTRIBUTION_URL, {
      section: SUPPLIERS,
      action: "search_products",
      supplier_id,
      str, product_type_id,
      output: JSON_STRING
    }),
  addProducts: ({ supplier_id, product_ids }) =>
    MHTTPCL.get(DISTRIBUTION_URL, {
      section: SUPPLIERS,
      action: "add_products",
      supplier_id,
      product_ids,
      output: JSON_STRING
    }),
  loadSupplierProducts: ({ supplier_id }) =>
    MHTTPCL.get(DISTRIBUTION_URL, {
      section: SUPPLIERS,
      action: "load_supplier_products",
      supplier_id,
      output: JSON_STRING
    }),

  fetchDistributionSupplierOverviewTabSetup: supplier_id =>
    MHTTPCL.get(DISTRIBUTION_URL, {
      section: SUPPLIERS,
      action: "supplier_details_tab_overview",
      supplier_id,
      output: JSON_STRING
    }),
  fetchDistributionSupplierCatalogueTabSetup: supplier_id =>
    MHTTPCL.get(DISTRIBUTION_URL, {
      section: SUPPLIERS,
      action: "supplier_details_tab_catalogue",
      supplier_id,
      output: JSON_STRING
    }),
  fetchDistributionSupplierOrderTabSetup: supplier_id =>
    MHTTPCL.get(DISTRIBUTION_URL, {
      section: SUPPLIERS,
      action: "supplier_details_tab_orders",
      supplier_id,
      output: JSON_STRING
    }),
  fetchDistributionSupplierInvoiceCostTabSetup: supplier_id =>
    MHTTPCL.get(DISTRIBUTION_URL, {
      section: SUPPLIERS,
      action: "supplier_details_tab_invoice_costs",
      supplier_id,
      output: JSON_STRING
    }),
  deleteContactRelation: (contact_relation_id) => MHTTPCL.post(CONTACTS_URL, {
    action: "delete_relation",
    contact_relation_id: contact_relation_id
  }),


  addSupplierOrder: ({ supplier_id, supply_order_type }) => MHTTPCL.post(DISTRIBUTION_URL, {
    section: SUPPLIERS,
    action: "add_supplier_order",
    supplier_id,
    supply_order_type
  }),
  createSupplierOrderModalData: ({ supplier_id }) => MHTTPCL.post(DISTRIBUTION_URL, {
    section: SUPPLIERS,
    action: "create_supplier_order_modal_data",
    supplier_id,

  }),

}